import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import { Footer, Navbar, Topbar } from './components';
import { useUser } from 'hooks/me';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 56,
    height: '100vh',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64,
    },
  },
  shiftContent: {
    paddingLeft: 200,
  },
  content: {
    backgroundColor: theme.palette.background.default,
  },
}));

const Main = props => {
  useUser(); // initialize user
  const { children, noFooter } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop,
      })}
    >
      <Topbar onSidebarOpen={() => setOpenNavBarMobile(true)} />
      <Navbar
        onMobileClose={() => setOpenNavBarMobile(false)}
        openMobile={openNavBarMobile}
      />
      <main className={classes.content}>
        {children}
        {!noFooter ? <Footer /> : null}
      </main>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node,
};

export default Main;
